module.exports = __webpack_public_path__ + "static/media/meet-on-coffee.efcbff1b.svg";